export const SET_SINGLE_APPOINTMENT = 'SET_SINGLE_APPOINTMENT';
export function setSingleAppointment(data) {
  return {
    type: SET_SINGLE_APPOINTMENT,
    payload: data,
  };
}
